/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    CodeAndLabel,
    CodeAndLabelFromJSON,
    CodeAndLabelFromJSONTyped,
    CodeAndLabelToJSON,
    CodeAndLabelWithIndent,
    CodeAndLabelWithIndentFromJSON,
    CodeAndLabelWithIndentFromJSONTyped,
    CodeAndLabelWithIndentToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface SSRRuleFormConfiguration
 */
export interface SSRRuleFormConfiguration {
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof SSRRuleFormConfiguration
     */
    readonly suppliers?: Array<GuidIdAndLabel> | null;
    /**
     * 
     * @type {Array<BrandAndMarketListItem>}
     * @memberof SSRRuleFormConfiguration
     */
    brandAndMarkets?: Array<BrandAndMarketListItem> | null;
    /**
     * 
     * @type {Array<CodeAndLabel>}
     * @memberof SSRRuleFormConfiguration
     */
    readonly timeZones?: Array<CodeAndLabel> | null;
    /**
     * 
     * @type {Array<CodeAndLabelWithIndent>}
     * @memberof SSRRuleFormConfiguration
     */
    readonly regions?: Array<CodeAndLabelWithIndent> | null;
}

export function SSRRuleFormConfigurationFromJSON(json: any): SSRRuleFormConfiguration {
    return SSRRuleFormConfigurationFromJSONTyped(json, false);
}

export function SSRRuleFormConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): SSRRuleFormConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'suppliers': !exists(json, 'suppliers') ? undefined : (json['suppliers'] === null ? null : (json['suppliers'] as Array<any>).map(GuidIdAndLabelFromJSON)),
        'brandAndMarkets': !exists(json, 'brandAndMarkets') ? undefined : (json['brandAndMarkets'] === null ? null : (json['brandAndMarkets'] as Array<any>).map(BrandAndMarketListItemFromJSON)),
        'timeZones': !exists(json, 'timeZones') ? undefined : (json['timeZones'] === null ? null : (json['timeZones'] as Array<any>).map(CodeAndLabelFromJSON)),
        'regions': !exists(json, 'regions') ? undefined : (json['regions'] === null ? null : (json['regions'] as Array<any>).map(CodeAndLabelWithIndentFromJSON)),
    };
}

export function SSRRuleFormConfigurationToJSON(value?: SSRRuleFormConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'brandAndMarkets': value.brandAndMarkets === undefined ? undefined : (value.brandAndMarkets === null ? null : (value.brandAndMarkets as Array<any>).map(BrandAndMarketListItemToJSON)),
    };
}


